import { BiSolidError } from "react-icons/bi";

function FailedTransaction() {
  return (
    <div className="text-center">
      <div className="flex !h-[70vh] flex-col items-center justify-center ">
          <div className="flex !h-[70vh] flex-col items-center   justify-center">
            <h1>
                <div className="">
                    <BiSolidError className="mx-auto text-9xl text-red-500" />
                    <div className="text-start">
                    <h3 className="my-3 font-bold">
                        Payment has been failed.
                    </h3>
                    </div>
                </div>
            </h1>
          </div>
      </div>
    </div>
  );
}

export default FailedTransaction;
